// extracted by mini-css-extract-plugin
module.exports = {"container":"wGIh+","type":"Hao7m","selected":"_1+GaQ","image":"PvrsY"};